import type { SlicingModelInfo } from "@/api/pizza-checker/schemas";

/** Geometry helpers of the slicing layer (src/components/evaluation/slicing-overlay.tsx). */

export const SLICE_COLORS = {
  ok: "#16a34a",
  small: "#dc2626",
} as const;

/** overlay = hatched slices over the photo; source = the bare photo (crossing ticks outside the rim) */
export type SlicingViewMode = "overlay" | "source";

export interface SlicingFrame {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface DisplaySlice {
  /** 1-based number in display order: clockwise from 12 o'clock */
  number: number;
  startAngle: number;
  endAngle: number;
  sweep: number;
  fraction: number;
  status: "ok" | "small";
}

/** slices clockwise from the one containing 12 o'clock (270 deg in the image convention) */
export function displaySlices(slicing: SlicingModelInfo | null | undefined): DisplaySlice[] {
  const slices = slicing?.slices ?? [];
  const fromTop = (a: number) => (a - 270 + 360) % 360;
  return [...slices]
    .sort((a, b) => {
      // the slice that contains 12 o'clock first
      const ka = fromTop(a.start_angle) > 360 - a.sweep_deg ? -1 : fromTop(a.start_angle);
      const kb = fromTop(b.start_angle) > 360 - b.sweep_deg ? -1 : fromTop(b.start_angle);
      return ka - kb;
    })
    .map((s, i) => ({
      number: i + 1,
      startAngle: s.start_angle,
      endAngle: s.end_angle,
      sweep: s.sweep_deg,
      fraction: s.area_fraction,
      status: s.status === "small" ? "small" : "ok",
    }));
}
